import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Card, Button, Typography, message, Modal } from 'antd';
import { ExperimentOutlined, ToolOutlined, CarOutlined, SafetyOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';

const { Title, Text } = Typography;

const ExamSelection = () => {
  const [examHistory, setExamHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startingExam, setStartingExam] = useState(false);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  // 获取用户考试历史
  useEffect(() => {
    const fetchExamHistory = async () => {
      try {
        // 添加日志以便调试
        console.log('正在获取考试历史...');
        console.log('当前请求头:', axios.defaults.headers.common);
        
        const res = await axios.get('/api/exams/history');
        setExamHistory(res.data);
        console.log('成功获取考试历史:', res.data);
      } catch (err) {
        console.error('获取考试历史失败:', err);
        
        // 如果是未授权错误，可以显示更友好的提示
        if (err.response && err.response.status === 401) {
          message.error('登录已过期，请重新登录');
          // 可选：重定向到登录页面
          // navigate('/login');
        } else {
          message.error('获取考试历史失败');
        }
        
        // 即使出错，也要设置加载状态为false
        setLoading(false);
        
        // 使用空数组作为考试历史，以便UI能正常显示
        setExamHistory([]);
      } finally {
        setLoading(false);
      }
    };

    fetchExamHistory();
  }, []);

  // 检查指定类别是否已通过
  const hasPassed = (category) => {
    return examHistory.some(exam => 
      exam.professionalCategory === category && 
      exam.status === '通过'
    );
  };

  // 开始新考试
  const startExam = async (category) => {
    if (hasPassed(category)) {
      Modal.info({
        title: '提示',
        content: '您已通过此类别考试，不能再次参加',
      });
      return;
    }

    try {
      setStartingExam(true);
      const res = await axios.post('/api/exams/start', {
        professionalCategory: category
      });

      navigate('/exam', { 
        state: { 
          examId: res.data.examId, 
          questions: res.data.questions,
          category
        } 
      });
    } catch (err) {
      if (err.response?.data?.msg) {
        message.error(err.response.data.msg);
      } else {
        message.error('开始考试失败');
      }
      console.error(err);
    } finally {
      setStartingExam(false);
    }
  };

  const examCategories = [
    {
      key: '机加工',
      title: '机加工',
      icon: <ToolOutlined style={{ fontSize: 48 }} />,
      description: '机械加工相关安全知识考试',
      color: '#1890ff'
    },
    {
      key: '电工',
      title: '电工',
      icon: <ExperimentOutlined style={{ fontSize: 48 }} />,
      description: '电气工作相关安全知识考试',
      color: '#52c41a'
    },
    {
      key: '汽车维修',
      title: '汽车维修',
      icon: <CarOutlined style={{ fontSize: 48 }} />,
      description: '汽车维修相关安全知识考试',
      color: '#fa8c16'
    },
    {
      key: '信息安全',
      title: '信息安全',
      icon: <SafetyOutlined style={{ fontSize: 48 }} />,
      description: '信息安全相关知识考试',
      color: '#eb2f96'
    }
  ];

  return (
    <div>
      <Title level={2}>考试中心</Title>
      <Text style={{ marginBottom: 24, display: 'block' }}>
        欢迎 {user?.name || '用户'}，请选择要参加的考试类别。注意：每个类别的考试通过后将不能再次参加。
      </Text>

      <Row gutter={[16, 16]}>
        {examCategories.map(category => (
          <Col xs={24} sm={12} md={6} key={category.key}>
            <Card 
              hoverable 
              style={{ 
                height: '100%',
                borderTop: `2px solid ${category.color}`
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: 16 }}>
                {category.icon}
              </div>
              <Title level={4} style={{ textAlign: 'center' }}>{category.title}</Title>
              <Text style={{ display: 'block', textAlign: 'center', marginBottom: 16 }}>
                {category.description}
              </Text>
              <div style={{ textAlign: 'center' }}>
                <Button 
                  type="primary" 
                  loading={startingExam} 
                  onClick={() => startExam(category.key)}
                  disabled={hasPassed(category.key)}
                  block
                >
                  {hasPassed(category.key) ? '已通过' : '开始考试'}
                </Button>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: 24 }}>
        <Title level={3}>考试说明</Title>
        <ul>
          <li>每次考试包含50道题目（35道选择题+15道判断题）</li>
          <li>其中40道专业题目，10道消防安全题目</li>
          <li>每题2分，满分100分，80分及格</li>
          <li>考试时间为60分钟，可提前交卷</li>
          <li>已通过的考试类别不能再次参加</li>
          <li>未通过的考试可以重复参加，直到通过</li>
        </ul>
      </div>
    </div>
  );
};

export default ExamSelection; 